export default "__VITE_ASSET__L1sW0G8t__"